<template>
  <component
    :is
    :class="
      mepTypeVariants({
        scheme,
        variant: resolvedVariant,
        bold,
      })
    "
    class="mep-type"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { useBreakpoints } from '@vueuse/core';
import { BREAKPOINTS } from '@/constants';
import { computed } from 'vue';
import { mepTypeVariants } from './constants';
import { MepTypeProps } from './types';

const breakpoints = useBreakpoints(BREAKPOINTS);

const props = withDefaults(
  defineProps<{
    is?: keyof HTMLElementTagNameMap;

    variant?: MepTypeProps['variant'];
    scheme?: MepTypeProps['scheme'];

    bold?: boolean;

    /**
     * Optional breakpoint variants to resolve the variant based on the current breakpoint. Breakpoint variant is applied to its own breakpoint and larger.
     *
     * If not provided, the `variant` prop will be used.
     */
    breakpointVariants?: Partial<Record<keyof typeof BREAKPOINTS, MepTypeProps['variant']>>;
  }>(),
  {
    is: 'p',

    variant: 'body-medium',
    scheme: 'onSurface',
    breakpointVariants: undefined,
  }
);

const resolvedVariant = computed(() => {
  if (props.breakpointVariants) {
    const breakpoint = Object.keys(props.breakpointVariants).find(
      (key) => breakpoints.greaterOrEqual(key as keyof typeof BREAKPOINTS).value
    );
    return props.breakpointVariants[breakpoint as keyof typeof BREAKPOINTS] || props.variant;
  }
  return props.variant;
});
</script>
<style>
a.mep-type,
.mep-type a {
  color: var(--theme-primary) !important;
  text-decoration: underline !important;
}
.mep-type {
  white-space: normal;
  word-break: break-word;
}
</style>
